import { CreateMuscleTag, MuscleTag } from '@/generated';
import { muscleTagApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';

const refreshChannel = new BroadcastChannel('muscle-tag-refresh');

export const useCreateMuscleTag = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createMuscleTagDTO: CreateMuscleTag) => muscleTagApi.muscleTagCreate({ createMuscleTag: createMuscleTagDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.MuscleTags] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateMuscleTag = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateMuscleTag: MuscleTag) => muscleTagApi.muscleTagUpdate({ muscleTag: updateMuscleTag }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.MuscleTags] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useDeleteMuscleTag = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (muscleTagId: string) => muscleTagApi.muscleTagDelete({ tagId: muscleTagId }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.MuscleTags] });
      refreshChannel.postMessage('refresh');
    },
  });
};
